import h from 'hyperscript';

import { Switch } from 'ui/switch/switch';

import { type ChangeEvent, on, unByKey } from 'cadenza/utils/event-util';
import { assert } from 'cadenza/utils/custom-error';
import type { ClusterDto } from 'cadenza/api-client/layer-config-dto';

import i18n from './cluster-configuration.properties';

const COMPONENT_NAME = 'd-cluster-config';

export class ClusterConfiguration extends HTMLElement {

  _model;
  _switch;
  _changeEventKey;

  constructor (model: ClusterDto) {
    super();
    assert(model, 'Argument \'model\' is mandatory');
    this._model = model;
    this._switch = new Switch({ checked: model.showClassificationInCluster });
    this._changeEventKey = on(this._switch, 'change', (event: ChangeEvent) => {
      const detail = event.detail as { checked: boolean };
      this._model.showClassificationInCluster = detail.checked;
    });
  }

  connectedCallback () {
    this.classList.add(COMPONENT_NAME);
    this._render();
  }

  disconnectedCallback () {
    unByKey(this._changeEventKey);
  }

  get state () {
    return this._model;
  }

  _render () {
    this.append(
      h('.form-group', [
        h('label', i18n('display-classification-as-circular-chart.title')),
        this._switch
      ])
    );
  }

}

customElements.define(COMPONENT_NAME, ClusterConfiguration);
